import { getDataIdsFromContract } from '../../shared/utils/dataId';

export const wizardHeaderDataIds = getDataIdsFromContract({
  base: 'wizard-header',
  container: '',
  back: 'back',
  cancelBtn: 'cancel'
});
